import Catalog from "@/views/Catalog.vue";

const routes = [
  {
    path: "",
    name: "Catalog",
    component: Catalog,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js